import { useState } from "react";
import { VideoCameraIcon, ArrowPathIcon } from "@heroicons/react/24/solid";
import { ModalProvider } from "../../store/context/ModalContext.js";
import { useResponsive } from "../../hooks/useResponsive.js";
import Button from "./Button.js";
import VideoTrailer from "../VideoTrailer/VideoTrailer.js";
import { useSelector } from "react-redux";
import { useUpdateViewMutation } from "../../services/modulesuser/videoListApi"; // <— importa qui

function TrailerButton({ video, videoId, index = false }) {
  const { watchlistMovies = [] } = useSelector((state) => state.user);
  const isUnfinished = watchlistMovies.some((v) => v.id === videoId);
  const foundVideo = watchlistMovies.find((v) => v.id === videoId);
  const title = foundVideo ? foundVideo.title : null;

  const { isSM } = useResponsive();
  const shouldHideIcon = index && isSM;

  const [restartSeq, setRestartSeq] = useState(0);
  const [updateView] = useUpdateViewMutation(); // <— mutation

  const handleRestart = async () => {
    try {
      // 1) azzera lato server
      await updateView({ videoId, completed: false, lastTime: 0 });
    } finally {
      // 2) forza remount del player
      setRestartSeq((n) => n + 1);
    }
  };

  return (
    <>
      <div className="flex gap-3 items-center">
        <ModalProvider.Trigger name="trailer" title={title}>
          <Button label="Watch the trailer">
            <span>
              {!shouldHideIcon && (
                <VideoCameraIcon className="w-8 inline-block pb-1 mr-2" />
              )}
              {!isUnfinished ? "GUARDA ORA" : "CONTINUA A GUARDARE"}
            </span>
          </Button>
        </ModalProvider.Trigger>

        {isUnfinished && (
          <ModalProvider.Trigger name="trailer" title={title}>
            <Button label="Restart trailer" onClick={handleRestart}>
              <span className="flex items-center">
                <ArrowPathIcon className="w-6 h-6 inline-block mr-1" />
                Ricomincia
              </span>
            </Button>
          </ModalProvider.Trigger>
        )}
      </div>

      <ModalProvider.Content name="trailer" alternative={true} title={title}>
        <VideoTrailer
          key={`vt_${videoId}_${restartSeq}`}  // <— remount sicuro
          video={video}
          videoId={videoId}
        />
      </ModalProvider.Content>
    </>
  );
}

export default TrailerButton;
